<template>
  <div class="bg" v-show="show">
    
    <div class="wrapper">
      <img @click="cancel" class="close" src="../../assets/img/cloudEdit/close.png" alt="">
      
      <div class="title-container">新建直播剪辑</div>

      <div class="project-container">
        <p><span style="color: #FF555A">*</span>名称</p>
        <input v-model="info.title" placeholder="名称" type="text">
      </div>

      <div class="stream-container">
        <p><span style="color: #FF555A">*</span>直播地址</p>
        <input v-model="info.url" disabled placeholder="直播地址" type="text">
      </div>

      <div class="size-container">
        <div v-click-outside="closeCard" class="name">
          <p>分辨率</p>
          <!-- <input v-model="ratio" placeholder="分辨率" type="text"> -->
          <div @click="showFilter = true" class="selectName">{{rateList[orderbyIndex]}}</div>
          <div v-if="showFilter" class="select-container">
            <p></p>
            <ul>
              <li v-for="(item,index) in rateList" :key="index" @click="orderbyIndex = index;showFilter = false" :class="{on: orderbyIndex == index}">
                <p class="title">{{item}}</p>
                <i class="gou"></i>
              </li>
            </ul>
          </div>
        </div>
        
        <!-- <ul>
          <li class="on">
            <div class="wh"></div>
            <p>16：9</p>
          </li>
          <li>
            <div class="hw"></div>
            <p>9：16</p>
          </li>
        </ul> -->
      </div>

      <div @click="newInsert" class="btn-container">
          确定
      </div>
    </div>
  </div>
</template>

<script>
import common from '@common/common'
import {apis} from '@common/config'
import vClickOutside from 'v-click-outside'

export default {
  name: 'cloudEditConfirm',
  directives: {
      clickOutside: vClickOutside.directive
  },
  data() {
    return {
      show: true,
      orderbyIndex: 0,
      rateList: [
        '1080P',
        '720P'
      ],
      showFilter: false,
      info: {
        title: '',
        detail: ''
      },
      r: null,
      stream_url: '',
      ratio: '',
      canSubmit: true
    }
  },
  methods: {
    closeCard() {
      this.showFilter = false;
    },
    newInsert() {
      if(this.info.title == '') {
        this.$toast("名称不能为空");
      }else{
        if(this.canSubmit){
          this.canSubmit = false;
          const info = {
            idstring: this.info.idstring,
            stream_id: this.info.id,
            type: 2,
            title: this.info.title,
            stream_url: this.info.url,
            ratio: this.ratio
          }

          common.myFetch(apis.editvideoInsert, {method: 'post', data: info})
          .then((data) => {
              if (!data) return
              this.canSubmit = true;
              this.close();
              this.r(data)
          })
        }
      }
    },
    open(info, r) {
      this.info = info
      this.r = r
      this.show = true
    },
    close() {
      this.show = false
    },
    confirm() {
      this.r(true)
      this.close()
    },
    cancel() {
      this.r('999')
      this.close()
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/css/global.less';
  .bg {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.70);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1222;

    .wrapper {
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -420px;
      margin-top: -203px;
      width: 840px;
      height: 406px;
      background: #1C1E26;
      border-radius: 4px;
      padding: 50px 80px 60px;
      box-sizing: border-box;

      .close {
        position: absolute;
        top: 20px;
        right: 30px;
        width: 22px;
        height: 22px;
        cursor: pointer;
        user-select: none;
      }

      .title-container {
        font-size: 18px;
        line-height: 25px;
        color: #FFFFFF;
        font-weight: bold;
      }

      .project-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 20px;
        margin-top: 30px;
        padding-left: 40px;
        box-sizing: border-box;

        p {
          width: 84px;
          font-size: 14px;
          color: #FFFFFF;
          margin-right: 20px;
          display: flex;
          justify-content: flex-end;
        }

        input {
          width: 496px;
          height: 40px;
          background: #222631;
          border-radius: 4px;
          padding: 0 20px;
          font-size: 14px;
          color: #FFF;

          &::placeholder {
            color: #878A94;
          }
        }
      }

      .stream-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 20px;
        padding-left: 40px;
        box-sizing: border-box;

        p {
          width: 84px;
          font-size: 14px;
          color: #FFFFFF;
          margin-right: 20px;
          display: flex;
          justify-content: flex-end;
        }

        input {
          width: 496px;
          height: 40px;
          background: #222631;
          border-radius: 4px;
          padding: 0 20px;
          font-size: 14px;
          color: #FFF;

          &::placeholder {
            color: #878A94;
          }
        }
      }

      .size-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 40px;
        padding-left: 40px;
        box-sizing: border-box;

        .name {
          position: relative;
          display: flex;
          flex-direction: row;
          align-items: center;

          &>p {
            width: 84px;
            font-size: 14px;
            color: #FFFFFF;
            margin-right: 20px;
            display: flex;
            justify-content: flex-end;
          }

          .selectName {
            width: 496px;
            height: 40px;
            line-height: 40px;
            background: #222631;
            border-radius: 4px;
            padding: 0 20px;
            font-size: 14px;
            color: #FFF;
          }

          .select-container {
            position: absolute;
            top: 40px;
            right: 0;
            width: 496px;
            z-index: 99;

            p {
              width: 100%;
              height: 10px;
              background: transparent;
            }

            ul {
              width: 100%;
              border-radius: 4px;
              overflow: hidden;
              background: #FFFFFF;
              
              li {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                height: 30px;
                background: #FFFFFF;
                padding: 0 10px 0 20px;
                box-sizing: border-box;

                &:hover {
                  background: rgba(65, 180, 140, 0.15);
                }

                .title {
                  height: 30px;
                  font-size: 14px;
                  line-height: 30px;
                  color: #050F0F;
                }

                &.on {
                  background: rgba(65, 180, 140, 0.15);

                  .gou {
                    display: block;
                    width: 14px;
                    height: 11px;
                    background: url('../../assets/img/common/select.svg') no-repeat;
                  }
                }
              }
            }
          }
        }

        input {
          width: 496px;
          height: 40px;
          background: #222631;
          border-radius: 4px;
          padding: 0 20px;
          font-size: 14px;
          color: #FFF;

          &::placeholder {
            color: #878A94;
          }
        }

        // ul {
        //   display: flex;
        //   flex-direction: row;
        //   align-items: center;

        //   li {
        //     display: flex;
        //     flex-direction: column;
        //     justify-content: center;
        //     align-items: center;
        //     width: 228px;
        //     height: 158px;
        //     background: #222631;
        //     border-radius: 4px;
        //     margin-right: 40px;
        //     user-select: none;
        //     cursor: pointer;

        //     &.on {
        //       border: 2px solid #4488FF;
        //       box-sizing: border-box;
        //     }

        //     &:nth-last-of-type(1) {
        //       margin-right: 0;
        //     }

        //     p {
        //       font-size: 18px;
        //       line-height: 25px;
        //       color: #878A94;
        //     }

        //     .wh {
        //       width: 56px;
        //       height: 36px;
        //       border: 3px solid #878A94;
        //       box-sizing: border-box;
        //       border-radius: 4px;
        //       margin-bottom: 18px;
        //     }

        //     .hw {
        //       width: 36px;
        //       height: 56px;
        //       border: 3px solid #878A94;
        //       box-sizing: border-box;
        //       border-radius: 4px;
        //       margin-bottom: 8px;
        //     }
        //   }
        // }
      }

      .btn-container {
        width: 320px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 14px;
        color: #FFF;
        background: #4488FF;
        border-radius: 25px;
        margin: 0 auto;
        user-select: none;
        cursor: pointer;
      }
    }
  }
</style>
